import React from "react";
import ReactDOM from "react-dom";
import closeImg from "../images/close.png";
import QuestionMarkIcon from "../images/Question_Mark_Icon.png";

function ConfirmModal(props) {
    const { modal, setModal, modalHeader, modalBody, modalFooter, onConfirm } = props;
    return ReactDOM.createPortal(
        <React.Fragment>
            <div
                className={"modal fade " + (modal ? "show " : "")}
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={modal ? { display: "block" } : { display: "none" }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-darkgrey p-2 px-3">
                            <h1
                                className="modal-title fs-16 text-white"
                                id="exampleModalLabel"
                            >
                                {modalHeader}
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                style={{
                                    backgroundImage: `url(${closeImg})`,
                                    opacity: 1,
                                    padding: "16px",
                                }}
                                onClick={() => setModal(false)}
                            ></button>
                        </div>
                        <div className="modal-body d-flex justify-content-center space-12">
                            <div className="p-3 d-flex">
                                <img src={QuestionMarkIcon} className="width-lg-18" alt="" />
                                <div>{modalBody}</div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <div className="col d-flex justify-content-end align-items-end">
                                <button
                                    onClick={() => {setModal(false); onConfirm() }}
                                    className="btn btn-md btn-secondary d-flex align-items-center px-4 fw-medium text-white rounded-3 mx-1"
                                >
                                    Yes
                                </button>
                                <button
                                    onClick={() => setModal(false)}
                                    className="btn btn-md btn-secondary d-flex align-items-center px-4 fw-medium text-white rounded-3 mx-1"
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modal ? <div className="modal-backdrop fade show" /> : ""}
        </React.Fragment>,
        document.getElementById("modal-root")
    );
}
export default ConfirmModal;